import React from 'react'



import 'react-slideshow-image/dist/styles.css';
import { Carousel } from "../Corousel/Carousel";

import data from "../../data/carouselData.json";
import imageOne from '../../resource/arama/annual-ceramony/1.png'
import imageFour from '../../resource/arama/annual-ceramony/4.png'
import imageFive from '../../resource/arama/annual-ceramony/5.png'
import imageThree from '../../resource/arama/annual-ceramony/2.png'
import TitleChnage from '../../Hook/TitleChnage'

import image1 from '../../resource/arama/annual-ceramony/Sannaspathraya.jpg'
import image2 from '../../resource/arama/annual-ceramony/imagetwo.png'

const AnnualArma = () => {

    TitleChnage("Annual Arma poojawa")

   

    return (
        <div className="annualArama-page inside-pages">
        <div className="right-box">
            <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
        </div>
    
        <h1 className='font-main  p-4 mt-4'>Annual Arama Pooja Ceremony</h1>
    
        <p className="mt-6 h4 p-4">The Bhaddeka Vihari Monastery and Retreat Centre organizes an annual Arama Pooja Ceremony, inviting many overseas senior Sangha, especially from Sri Lanka, to receive the "Sannaspathra" from devotees. This ceremony provides a remarkable opportunity for attendees to meet and pay their respects to these esteemed Sangha. In addition to the formalities, participants can listen to Dhamma sermons and engage in various events designed to uplift their hearts and minds through the teachings of the Dhamma.</p>
        <p className="mt-5 h4 p-4">You are cordially invited to join the noble endeavor of Arama Pooja, supporting the Bhaddeka Vihari Forest Monastery and retreat centre in repaying its existing $700,000 bank loan. </p>
        
     
        <div className="calander-box mt-6 p-4 align-item-center text-center">
            <div className="img1">
                <img src={image1} style={{ width: "100%" }} />
            </div>
            <div className="img2">
            <p className="mt-5 h4 p-4">Established in 2017, the monastery purchased a $2 million property. Despite the collective efforts of Buddhist Community, the funds raised were insufficient to cover the total cost, necessitating a $1.4 million bank loan. At the Arama Pooja devotees can purchase a $ 500 worthy land plot and offer the deed - “Sannaspathra” to the Arama. Your contribution to this meritorious cause is deeply appreciated.</p>
        <p className="mt-5 h4 p-4">Secure your dedication to this sacred space by acquiring one of the remaining 1,400 'Sannaspathra'. Participate in this virtuous act, supporting the creation of a lasting refuge for spiritual growth and development.</p>

            </div>
        </div>

        <p className="h4 text-center mt-6 text-bold ">Together, let's nurture a sanctuary for</p>
        <p className="h4 text-center text-bold ">mindfulness and wisdom.</p>
    
    
        <div className=" mt-6 p-4">
          <Carousel data={data.annualArama} />
        </div>
    
        <div className='btn-group2 mt-6'>
            <img src={imageFour} alt="Right Top Image" width={300} />
            <img src={imageFive} alt="Right Top Image" width={300} />
        </div>
    

        <div className="mt-6 calander-box align-item-center p-4 text-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Contact Details</h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
            
        </div>
    
            <div className="bottom-box mt-5">
            <img src={imageThree} alt="bottom-image"  width={600} />
        </div>
    
    </div>
    )
}

export default AnnualArma